import React, { useEffect, useMemo, useState } from "react";
import HeaderLogged from "componentsTemplate/Header/HeaderLogged";
import Header from "componentsTemplate/Header/Header";
import Header2 from "componentsTemplate/Header/Header2";
import HeaderEmpty from "components/headers/HeaderEmpty";
import { useLocation } from "react-router-dom";
import useAuth from "hooks/useAuth";

const SiteHeader = () => {
  const { token, user } = useAuth();
  let pathname = useLocation().pathname;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  const headerComponent = useMemo(() => {

    let HeadComponent = token ? HeaderLogged : Header2;
    
    switch (pathname) {
      case "/em-breve":
        HeadComponent = HeaderEmpty;
        break;
      case "/home-2":
        HeadComponent = Header;
        break;
      case "/home-3":
        HeadComponent = Header2;
        break;

      default:
        break;
    }

    return <HeadComponent />;
  }, [pathname, token, user]);

  return <>{headerComponent}</>;
};
export default SiteHeader;
